<div class="fixed-page-title">
    <div class="page-header">
      <div>
        <p class="page-title">
          {{resourceKeyValue.Facilities}}
        </p>
      </div>
      <div>
        <a id="btnCreateHospital" *ngIf="resourceKeyValue.hospitalCreateNewHospital" class="btn btn-primary"
          [routerLink]="['add-facility']">{{resourceKeyValue.hospitalCreateNewHospital}}</a>
      </div>
    </div>
  </div>
  <div class="form-title padding-top-4em">
    <form content [formGroup]="searchHospitalsForm" id="searchHospitalsForm" class="w-100">
      <div class="form-group">
        <div class="input-group mb-2 tertiary-search w-100">
          <div class="has-clear w-100">
            <input type="text" class="form-control w-25 term-input search-txt" id="term"
              placeholder={{resourceKeyValue.searchByFacilityName}} formControlName="term"
              (keyup)="search($event)">
          </div>
          <span class="input-group-append">
            <div class="input-group-text btn-tertiary-search border-0"><i class="icon-search-bold"></i></div>
          </span>
        </div>
      </div>
    </form>
  </div>
  
  <div *ngIf="!isLoading">
    <div class="table-responsive">
      <table id="hospitalTable" class="table table-striped table-hover" #hospitalTable>
        <thead class="column-sort">
          <tr>
            <th (click)="sortableState ='1'; isDefaultSort=false"
              [ngClass]="[sortableState == '1' ? 'sorting':'' ,isDefaultSort==true ? 'sorted-asc':'',hospitals?.length===0?'disabled-header':'']"
              scope="col" [appSort]="hospitals" data-order="desc" data-name="name" tabindex="0"
              class="tabfocusable initialSort w-20">
              <span>{{resourceKeyValue.hospitalName}}</span>
            </th>
            <th (click)="sortableState ='2'"
              [ngClass]="{'sorting':sortableState == '2','disabled-header':hospitals?.length===0}" scope="col"
              [appSort]="hospitals" data-order="desc" data-name="idnName" tabindex="0" class="tabfocusable w-10">
              <span>{{resourceKeyValue.hospitalIdnName}}</span>
            </th>
            <th (click)="sortableState ='3'"
              [ngClass]="{'sorting':sortableState == '3','disabled-header':hospitals?.length===0}" scope="col"
              [appSort]="hospitals" data-order="desc" data-name="fullAddress" tabindex="0" class="tabfocusable w-20">
              <span>{{resourceKeyValue.hospitalAddressTable}}</span>
            </th>
            <th (click)="sortableState ='4'"
              [ngClass]="{'sorting':sortableState == '4','disabled-header':hospitals?.length===0}" scope="col"
              [appSort]="hospitals" data-order="desc" data-name="originatingDataSource" tabindex="0"
              class="tabfocusable w-15">
              <span>{{resourceKeyValue.originatingDataSource}}</span>
            </th>
            <th [ngClass]="{'disabled-header':hospitals?.length===0}" scope="col" class="text-right"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let hospital of hospitals | slice: (pageIndex-1) * pageSize : pageIndex * pageSize; index as i">
            <td scope="row">{{hospital.name}}</td>
            <td scope="row">{{hospital.idnName}}</td>
            <td scope="row">{{hospital.fullAddress}}</td>
            <td scope="row" class="ods-td">{{hospital.originatingDataSource}}</td>
            <td scope="row" class="text-right">
              <button class="btn btn-sm btn-secondary"
                [routerLink]="['edit-facility',hospital.id]">{{resourceKeyValue.edit}}</button>
            </td>
          </tr>
          <tr *ngIf="hospitals?.length===0">
            <td colspan="7" class="empty-grid">
              <p class="empty-grid-header">{{resourceKeyValue.noDataAvailable}}</p>
              <p class="empty-grid-body-text">{{resourceKeyValue.noFacilityDetails}}</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="table-footer" *ngIf="hospitals?.length>0">
      <div id="pagination" style="display: block;">
        {{resourceKeyValue.page}} <b>{{pageIndex}}</b> {{resourceKeyValue.of}} {{numberOfPages}}
      </div>
      <div class="rpp">
        <span>{{resourceKeyValue.showRows}}</span>
        <div class="dropdown dropdown-sm" role="navigation">
          <button class="btn btn-sm dropdown-toggle" type="button" data-toggle="dropdown" id="pagination"
            aria-haspopup="true" aria-expanded="false" aria-controls="dropdownPagination">{{pageSizeDisplay}}</button>
          <div class="dropdown-menu" aria-labelledby="pagination" id="dropdownPagination">
            <ng-container *ngFor="let page of pageSizeOptions">
              <button *ngIf='isNumber(page)' (click)="pageSizeDisplay=page; pageSize=page; refreshHospitals();"
                role="menuitem" ngbDropdownItem>{{page}}</button>
              <button *ngIf='!isNumber(page)'
                (click)="pageSizeDisplay=page.showAll; pageSize=hospitals?.length; refreshHospitals();" role="menuitem"
                ngbDropdownItem>{{page.showAll}}</button>
            </ng-container>
          </div>
        </div>
      </div>
      <ngb-pagination class="d-flex justify-content-end" [boundaryLinks]="true" [collectionSize]="totalNumber"
        [(page)]="pageIndex" [maxSize]=5 [pageSize]="pageSize">
      </ngb-pagination>
    </div>
  </div>
  <app-loader [isLoading]=isLoading></app-loader>